/** The feedback form and its button. */
export default {
  sendFeedback: "Send feedback",
  typeBug: "Bug report",
  typeFeature: "Feature request",
  typeAiContent: "Report AI content",
  typeOther: "Other",
  tooManyReports: "You've sent several reports. Please try again later.",
  checkMessage:
    "Check your message and screenshots, then try again. Screenshots must be PNG, JPEG or WebP and total 3 MB or less.",
  sendFailed:
    "We couldn't send your feedback. Your draft is kept here; please try again.",
  reportReceived: "Report received",
  thanks: "Thanks for your feedback!",
  sentForReview: "Sent to Denker support for review.",
  reportTitle: "Report inappropriate AI content",
  feedbackTitle: "Feedback",
  closeFeedback: "Close feedback",
  reportPlaceholder:
    "Describe the AI content you want to report. You can paste an excerpt.",
  feedbackPlaceholder: "What's on your mind?",
  reportAria: "AI content report",
  messageAria: "Feedback message",
  privacyNote:
    "Sent to Denker support with your account email. Attach only what you want to share.",
  removeScreenshot: "Remove {name}",
  addScreenshots: "Add screenshots, up to 3 MB total",
  screenshot: "Screenshot",
  sending: "Sending…",
  sendReport: "Send report",

  // Attachments
  attachLimit: "Attach up to three screenshots.",
  attachType: "Choose a PNG, JPEG or WebP screenshot.",
  attachSize: "Screenshots must total 3 MB or less.",
} as const;
